import React, { Fragment } from 'react'

const decimalSeparator = locale => {
  const config = {
    fr: ',',
    en: '.',
  }

  // rules are same than FR in other supported languages

  return config[locale] || config.fr
}

const thousandsSeparator = locale => {
  const config = {
    fr: '.',
    en: ',',
  }
  return config[locale] || config.fr
}

export const getFormattedPrice = (number, locale) => {
  const decimalsCount = number - Math.floor(number) > 0 ? 2 : 0
  let formattedNumber = parseFloat(number).toFixed(decimalsCount)

  formattedNumber = formattedNumber.replace('.', decimalSeparator(locale))
  formattedNumber = formattedNumber.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandsSeparator(locale)}`)

  return formattedNumber
}

export const formatCurrency = (number, currency, locale) => {
  const formattedNumber = getFormattedPrice(number, locale)
  const formattedCurrency = currencySign(currency)

  if (currency === 'eur') {
    return `${formattedNumber} ${formattedCurrency}`
  }
  else {
    return `${formattedCurrency} ${formattedNumber}`
  }
}

export const formatCustomCurrency = (currency, formattedIntPrice, formattedDecimalPrice, formattedCurrency, locale) => {
  formattedDecimalPrice = formattedDecimalPrice && formattedDecimalPrice < 10 ? `0${formattedDecimalPrice}` : formattedDecimalPrice
  if (currency === 'eur') {
    return <Fragment>{formattedIntPrice}<sup>&#8202;{formattedDecimalPrice && `${decimalSeparator(locale)}${formattedDecimalPrice}`}{formattedCurrency}</sup></Fragment>
  }
  else {
    return <Fragment>{formattedCurrency}{formattedIntPrice}{formattedDecimalPrice && <sup>&#8202;{decimalSeparator(locale)}{formattedDecimalPrice}</sup>}</Fragment>
  }
}

export const currencySign = currency => {
  switch (currency) {
    case 'eur': return '€'
    case 'usd': return '$'
    case 'gbp': return '£'
    default: return currency.toUpperCase()
  }
}
